module.exports = __webpack_public_path__ + "static/media/C18.ca117705.png";